<template>
  <path
    d="M12 7.00024V5.00024C12 3.90024 11.1 3.00024 10 3.00024H4C2.9 3.00024 2 3.90024 2 5.00024V19.0002C2 20.1002 2.9 21.0002 4 21.0002H20C21.1 21.0002 22 20.1002 22 19.0002V9.00024C22 7.90024 21.1 7.00024 20 7.00024H12ZM10 19.0002H4V17.0002H10V19.0002ZM10 15.0002H4V13.0002H10V15.0002ZM10 11.0002H4V9.00024H10V11.0002ZM10 7.00024H4V5.00024H10V7.00024ZM20 19.0002H12V9.00024H20V19.0002ZM18 11.0002H14V13.0002H18V11.0002ZM18 15.0002H14V17.0002H18V15.0002Z"
  />
</template>
